var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-skeleton"},[(_vm.$route.path !== '/login')?_c('app-header'):_vm._e(),_c('main',{},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }